/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { driver } from 'driver.js';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { GetUserProductTourDetails } from "../../../redux/constants/apiConstants";
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

class Walkthrough extends Component {
  constructor(props) {
    super(props);
    this.driver = driver({
      showProgress: true,
      animate: true,
      keyboardControl: true,
      overlayClickNext: true,
      nextBtnText: 'Next',
      prevBtnText: 'Previous',
      doneBtnText: 'Finish',
      popoverClass: 'figma-tour-popover',
      onHighlightStarted: (element, step, options) => {
        this.handleStepChange(step);
      },
      onHighlight: (stepNumber) => {
        this.handleStepChange(stepNumber);
      },
      afterChange: (stepNumber) => {
        this.handleStepChange(stepNumber);
      },
      onCloseClick: (element, step, options) => {
        // console.log("Tour manually closed");
        this.props.productTourDetails?.product_tour_data?.admin_recognition ? this.handleFinishTour() : this.props.hideProductTour();
      },
      onDestroyStarted: (element, step, options) => {
        // console.log("Tour destroy started", step);
        // Optionally handle logic before destruction
      },
      onDestroyed: (element, step, options) => {
        // console.log("Tour fully destroyed", step);
        document.body.classList.remove('driver-on-first-step');
        document.body.classList.remove('driver-on-last-step');
        // this.props.hideProductTour();
      }
    });
    this.totalSteps = 17;
  }

  componentDidMount() {
    this.startTour();
  }

  componentDidUpdate(prevProps){
    if(prevProps.showWalkthrough != this.props.showWalkthrough){
      if(this.props.showWalkthrough){
        //document.body.classList.add('driver-on-first-step');
        this.startTour();
      }

    }

  }
  

  startTour = () => {
    const { setActiveTab, setSubTab } = this.props;
    const driverInstance = this.driver;

    this.driver.setSteps([
      {
        element: '#step1',
        popover: {
          title: 'Snapshot',
          description: 'Overview of key recognition and engagement metrics.',
          showButtons: ['next', 'close'],
          
        },
      },
      {
        element: '#snapshot-comparison',
        popover: {
          title: 'Comparison',
          description: 'Compare performance across departments, locations, or time periods.',
          position: 'right',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#yeardropdown',
        popover: {
          title: 'Year Filter',
          description: 'Filter your analytics or data based on a specific year to track long-term trends.',
          position: 'right',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#step2',
        popover: {
          title: 'Analytics',
          description: 'Dive deeper into engagement, recognition, and social activity insights.',
          position: 'right',
          showButtons: ['previous', 'next', 'close']
        },
      },
      
      {
        element: '#step3',
        popover: {
          title: 'Insights',
          description: 'View key highlights and smart summaries of user behavior.',
          position: 'right',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#step4',
        popover: {
          title: 'Performance',
          description: 'Track how individuals or teams are performing.',
          position: 'right',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#step5',
        popover: {
          title: 'Anniversaries',
          description: 'Access a dedicated section for work anniversaries and birthdays.',
          position: 'right',
          showButtons: ['previous', 'next', 'close'],
          onNextClick: () => {
            setActiveTab?.(5);
            const interval = setInterval(() => {
              if (document.querySelector('#filterSection')) {
                clearInterval(interval);
                driverInstance.moveNext();
              }
            }, 100);
          },
        },
      },
      {
        element: '#settingSection',
        popover: {
          title: 'Manage Anniversaries',
          description: 'Toggle visibility for anniversaries and birthdays.',
          position: 'bottom',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#filterSection',
        popover: {
          title: 'Department and location filter',
          description: 'Filter celebrations by team or office.',
          position: 'bottom',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#step6',
        popover: {
          title: 'Library',
          description: 'Browse all your company’s core values.',
          position: 'right',
          showButtons: ['previous', 'next', 'close'],
          onNextClick: () => {
            setActiveTab?.(6);
            const interval = setInterval(() => {
              if (document.querySelector('#eye-icon')) {
                clearInterval(interval);
                driverInstance.moveNext();
              }
            }, 100);
          },
        },
      },
      
      {
        element: '#eye-icon',
        popover: {
          title: 'Core value detail',
          description: "See an in-depth view of a specific core value and how it's being used.",
          position: 'bottom',
          showButtons: ['previous', 'next', 'close']
        },
      },
      {
        element: '#pencil-icon',
        popover: {
          title: 'Edit core value',
          description: 'Update the name, icon, description or point value of an existing core value.',
          position: 'bottom',
          showButtons: ['previous', 'next', 'close'],
          onNextClick: () => {
            // setSubTab('Inactive');
            this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6, activeTabV: "Inactive"}});
            const interval = setInterval(() => {
              if (document.querySelector('#launch')) {
                clearInterval(interval);
                driverInstance.moveNext();
              }
            }, 100);
            
          },
        },
      },
      
      {
        element: '#launch',
        popover: {
          title: 'Launch',
          description: 'Deploy a new core value across your organization for employees to engage with.',
          position: 'bottom',
          showButtons: ['previous', 'next', 'close'],
          onNextClick: () => {
            this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6, activeTabV: "Inactive"}});
            const interval = setInterval(() => {
              if (document.querySelector('#core-values')) {
                clearInterval(interval);
                driverInstance.moveNext();
              }
            }, 100);
            
          }
          
          
        },
      },
      
      {
        element: '#core-values',
        popover: {
          title: 'Create core value',
          description: 'Add a brand new core value to align with your company’s evolving goals.',
          position: 'bottom',
          showButtons: ['previous', 'next', 'close'],
          onNextClick: () => {
            this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6, activeTabV: "Archive"}});
            const interval = setInterval(() => {
              if (document.querySelector('#restore-delete')) {
                clearInterval(interval);
                driverInstance.moveNext();
              }
            }, 100);
            
          }
          
        },
      },
      {
        element: '#restore-delete',
        popover: {
          title: 'Restore core value',
          description: 'Re-activate a previously archived core value for current use.',
          position: 'bottom',
          showButtons: ['previous', 'close'],
          onNextClick: () => this.handleFinishTour()
        },
      },
      // {
      //   element: '#restore-icon',
      //   popover: {
      //     title: 'Restore core value',
      //     description: 'Re-activate a previously archived core value for current use.',
      //     position: 'bottom',
          
      //   },
      // },
      // {
      //   element: '#delete-icon',
      //   popover: {
      //     title: 'Delete core value',
      //     description: 'Remove a core value from the library and detach it from all past recognitions',
      //     position: 'bottom',
          
      //   },
      // },
      
    ]);
     
    this.driver.drive(); 
  };
  handleFinishTour = () => {
    const productTourPayload = {
      company_id: this.props.companyId, 
      product_tour_data: {
        admin_recognition: false,
      }
    };
    //setShowModal(false);
    this.props.hideProductTour();
    this.sendProductTourData(productTourPayload)
  };
  

  sendProductTourData = async (payload) => {
    try {
      const res = await fetchApi(GetUserProductTourDetails,  "POST", payload);
      if(res.status === "success"){
        toast.success(res?.data?.message)
        if (this.driver) {
          this.driver.destroy();  
        }
        
      }
      else {
        toast.error(res?.message?.message)
      }
      // if (res.data.success) {
      //   toast.error(res?.data?.message);
      // } else {
      //   toast.success(res?.data);
      //   //fetchCompanyCoreValues(companyInfo.id)
      // }
    }
    
    
    catch (error) {
      // toast.error(error)
    }
  }

  handleStepChange = (stepNumber) => {
    if (stepNumber === 1) {
      document.body.classList.add('driver-on-first-step');
      document.body.classList.remove('driver-on-last-step');
    } else if (stepNumber === this.totalSteps) {
      document.body.classList.add('driver-on-last-step');
      document.body.classList.remove('driver-on-first-step');
    } else {
      document.body.classList.remove('driver-on-first-step');
      document.body.classList.remove('driver-on-last-step');
    }
  };

  componentWillUnmount() {
    if (this.driver) {
      this.driver.destroy();
    }
    document.body.classList.remove('driver-on-first-step');
    document.body.classList.remove('driver-on-last-step');
    this.props.hideProductTour()
  }

  render() {
    return null;
  }
}

Walkthrough.propTypes = {
  setActiveTab: PropTypes.func,
  setSubTab: PropTypes.func,
  history:PropTypes.object,
  companyId:PropTypes.number,
  showWalkthrough:PropTypes.bool,
  hideProductTour:PropTypes.func,
  productTourDetails:PropTypes.object
};

const mapStateToProps = (state) => ({
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  productTourDetails: state.profileData.productTourDetails,

});

// export default connect(mapStateToProps, null)(RecognitionMain);

export default withRouter(connect(mapStateToProps, null)(Walkthrough));


